<template>
  <footer class="om-footer" app fixed>
    <div class="flex-none om-footer-tag">
      <div class="om-footer-tag-words">OLD<span>MUTUAL</span></div>
    </div>
    <v-row class="om-footer-content ma-5">
      <v-col cols="12" md="3" class="om-footer-content-column px-md-5">
        <p class="mb-2 om-footer-heading">About Old Mutual</p>
        <p class="mb-6 om-footer-blurb">
          Old Mutual Limited (OML) is a licensed Controlling Company of the
          Designated Old Mutual Limited Insurance Group. Registration number
          2017/235138/06. Entities in the Group are Licensed Financial Services
          Providers and Insurers that offer a broad spectrum of financial
          solutions to retail and corporate customers across key markets in 14
          countries<br /><br />Copyright Old Mutual Limited
          {{ new Date().getFullYear() }}
        </p>
      </v-col>
      <v-col cols="12" md="3" class="om-footer-content-column px-md-5">
        <p class="mb-2 om-footer-heading">Disclaimer</p>
        <p class="mb-6 om-footer-blurb">
          The Old Mutual Will is available to all South African citizens in
          possession of a legally valid Identification Document residing in
          South Africa. Unfortunately we do not currently provide the Old Mutual
          Will service outside the borders of South Africa.
        </p>
      </v-col>
      <v-col cols="12" md="3" class="om-footer-content-column px-md-5">
        <p class="mb-2 om-footer-heading">Terms and Privacy</p>
        <p class="mb-6 om-footer-blurb">
          <a href="https://www.oldmutual.co.za/privacy-notice" target="_blank"
            >Privacy Notice, Access and Data Protection</a
          >
          <br /><br />
          <router-link :to="{ name: termsAndConditionsComponent }"
            >Terms and Conditions</router-link
          >
        </p>
      </v-col>
      <v-col cols="12" md="3" class="om-footer-content-column px-md-5">
        <p class="mb-2 om-footer-heading">Contact Details</p>
        <p class="mb-6 om-footer-blurb">
          Email:
          <a class="text-gray-50" :href="'mailto:' + whitelabel.contactEmail">{{
            whitelabel.contactEmail
          }}</a>
          <br /><br />
          <span class="address">
            {{ whitelabel.contactAddress }}
          </span>
        </p>
      </v-col>
    </v-row>
  </footer>
</template>

<script>
export default {
  name: "OldMutualFooter",
  props: {
    home: {
      default: {},
      type: Object,
      required: false
    }
  },
  computed: {
    termsAndConditionsComponent() {
      if (this.home?.competition?.competitionActive) {
        return 'CompetitionTermsAndConditions'
      } else {
        return 'TermsAndConditions'
      }
    },
  }
};
</script>

<style scoped lang="scss">
@import "../../constants/styles/mixins.scss";

.om-footer {
  background-color: rgb(55 65 81);
  color: #fff;
  display: flex;
  margin-top: 42px;

  .om-footer-tag {
    flex: none;
    background: linear-gradient(0deg, #60b848, #009677);
    margin-left: 40px;
    margin-right: 30px;
    margin-top: -42px;
    width: 75px;
    z-index: 100;

    .om-footer-tag-words {
      margin-top: 151px;
      font-size: 1.5rem;
      line-height: 2rem;
      transform: translate(0, 0) rotate(-90deg) skewX(0) skewY(0) scaleX(1)
        scaleY(1);

      span {
        font-weight: 700;
      }
    }
  }

  .address {
    white-space: pre-line;
  }

  .om-footer-content {
    .om-footer-content-column {
      .om-footer-heading {
        font-size: 1.125rem;
        line-height: 1.75rem;
        font-weight: 500;
      }
      .om-footer-blurb {
        font-size: 0.875rem;
        line-height: 1.25rem;

        @include max-breakpoint(960px) {
          font-size: 0.75rem;
          line-height: 1rem;
        }

        a {
          color: inherit;
          text-decoration: inherit;
          font-size: inherit;
        }
      }
    }
  }
}
</style>
